import React from 'react'
import './css/HomePlanning.css'
import OccasionCard from './OccasionCard'
// import EventManagement from './../assets/images/OccasionEvent.jpeg'
// import CateringService from './../assets/images/OccasionCatering.jpeg'
// import VenueDecoration from './../assets/images/OccasionVenue.jpeg'
import Wedding from './../assets/images/ServicesWedding.jpeg'
import Corporate from './../assets/images/ServicesCorporate.jpeg'
import Social from './../assets/images/ServicesSocial.jpeg'

function HomePlanning() {
  return (
    <div className='HomePlanning'>
        <div className='overlay'></div>
        <h1>Planning a special occasion?</h1>
        <div className='cards'>
            {/* <OccasionCard image={EventManagement} text={"Event Management"} />
            <OccasionCard image={CateringService} text={"Catering Services"} />
            <OccasionCard image={VenueDecoration} text={"Venue Decoration"} /> */}
            <OccasionCard image={Wedding} text={"Weddings"} />
            <OccasionCard image={Corporate} text={"Corporate Events"} />
            <OccasionCard image={Social} text={"Social Events"} />
        </div>
    </div>
  )
}

export default HomePlanning